import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import "./Navbar.css";

const CustomNavbar = () => {
  const [expanded, setExpanded] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 992);
  const navRef = useRef(null);

  // Add resize listener
  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 992);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Navbar
      expand="lg"
      className={`custom-navbar ${expanded ? "expanded" : ""}`}
      expanded={expanded}
      ref={navRef}
    >
      <Container fluid className="px-3">
        <div className="d-flex align-items-center brand-container">
          <Navbar.Brand
            as={Link}
            to="/"
            className="brand d-flex align-items-center"
          >
            <img src="/NAEW1.png" alt="Logo" className="logo" />
            <span>New Age Engineering World</span>
          </Navbar.Brand>
        </div>

        <Navbar.Toggle onClick={() => setExpanded(!expanded)} />

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link as={Link} to="/" onClick={() => setExpanded(false)}>
              Home
            </Nav.Link>

            <NavDropdown
              title="Services"
              id="basic-nav-dropdown"
              onSelect={(eventKey) => {
                setExpanded(false);
              }}
            >
              <NavDropdown.Item as={Link} to="/3d-modeling">
                3D Modelling
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/design-services">
                Engineering Design
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/2d-modeling">
                Detail Engineering
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/tandd">
                Skill Development
              </NavDropdown.Item>
            </NavDropdown>

            <Nav.Link
              as={Link}
              to="/gallery"
              onClick={() => setExpanded(false)}
            >
              Gallery
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/contact"
              onClick={() => setExpanded(false)}
            >
              Contact us
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default CustomNavbar;
